var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeopen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.636 23.423c.433.561.813 1.081 1.137 1.547l.021.03-.021.03a43.64 43.64 0 0 1-5.326 6.25c-4.356 4.213-8.926 6.72-13.447 6.72-4.521 0-9.092-2.507-13.447-6.719a43.64 43.64 0 0 1-5.326-6.25L6.206 25l.021-.03a43.65 43.65 0 0 1 5.326-6.25c4.355-4.213 8.925-6.72 13.447-6.72 4.521 0 9.091 2.507 13.447 6.719a43.64 43.64 0 0 1 4.19 4.704Zm1.584 4.375c.453-.587.852-1.134 1.194-1.625.208-.298.352-.514.428-.634a1 1 0 0 0 0-1.078c-.076-.12-.22-.336-.428-.634a45.64 45.64 0 0 0-5.577-6.546C35.145 12.743 30.144 10 25 10s-10.145 2.743-14.838 7.281a45.614 45.614 0 0 0-5.577 6.546c-.207.298-.35.514-.427.634a1 1 0 0 0 0 1.078c.076.12.22.336.427.634a45.614 45.614 0 0 0 5.577 6.546C14.855 37.257 19.857 40 25 40c5.144 0 10.145-2.743 14.837-7.281a45.64 45.64 0 0 0 4.383-4.92ZM25.5 21a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 9a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen);
export default __webpack_public_path__ + "static/media/eyeopen.07c25868e50a3673849af41b96a85108.svg";
export { ForwardRef as ReactComponent };